<template>
  <div v-if="onBusinessHour" :style="style"></div>
</template>

<script>
import Moment from 'moment'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)

export default {
  name: 'ReservationTableTimePointer',
  props: {
    height: {
      type: Number,
      required: true,
    },
    startAt: {
      type: Object,
      required: true,
    },
    endAt: {
      type: Object,
      required: true,
    },
    pxPerMinute: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      timerId: null,
      left: 0,
      onBusinessHour: false,
    }
  },
  computed: {
    style () {
      return {
        top: '0px',
        left: `${this.left}px`,
        height: `${this.height}px`,
        width: '2px',
        'background-color': 'red',
        position: 'absolute',
      }
    },
  },
  methods: {
    update () {
      let range = moment.range(this.startAt, this.endAt)
      let now = moment()
      this.onBusinessHour = range.contains(now)
      this.left = now.diff(range.start, 'minute') * this.pxPerMinute
    },
  },
  mounted () {
    this.update()
    this.timerId = setInterval(this.update, 30000)
  },
  beforeDestroy () {
    if (this.timerId) {
      clearInterval(this.timerId)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Table/TimePointer.vue